export const FILE_LIST_DEFAULT_VALUE = [];

export const initialNotificationAlertsState = {
  conflictingFilesAlert: true,
  errorFilesAlert: true,
  newFilesAlert: true,
};
